"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CatalogSchedulePropType = exports.CatalogItemPropType = exports.CatalogCategoryPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var IdPropType = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]);
var CatalogSchedulePropType = _propTypes["default"].shape({
  _id: IdPropType.isRequired,
  name: _propTypes["default"].string.isRequired
});
exports.CatalogSchedulePropType = CatalogSchedulePropType;
var CatalogCategoryPropType = _propTypes["default"].shape({
  _id: IdPropType.isRequired,
  name: _propTypes["default"].string.isRequired,
  schedule: CatalogSchedulePropType
});
exports.CatalogCategoryPropType = CatalogCategoryPropType;
var CatalogItemPropType = _propTypes["default"].shape({
  _id: IdPropType.isRequired,
  name: _propTypes["default"].string.isRequired,
  category: CatalogCategoryPropType,
  locations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    location: _propTypes["default"].number
  }))
});
exports.CatalogItemPropType = CatalogItemPropType;